import React from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { SelectField } from 'redux-form-material-ui'
import SelectFieldMaterial from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import { missionPEField } from '../../../../../../utils/constants'

const IdOptionSelected = (answers) => {
  let id = null
  answers.forEach((answer) => {
    if (answer.selected) {
      id = answer.id
    }
  })
  return id
}

class SelectElement extends React.Component {

  required = value => value == null ? 'Requerido' : undefined

  render() {
    const { element, real_answer } = this.props
    if (real_answer) {
      const id = IdOptionSelected(real_answer.page_element_options)
      return (
        <SelectFieldMaterial
          id={real_answer.page_element_id}
          value={id}
          hintText="Elige una opción"
          fullWidth
        >
          {element.page_element_options.map(peo =>
            <MenuItem
              key={peo.id}
              value={peo.id}
              primaryText={peo.option_value}
            />,
          )}
        </SelectFieldMaterial>
      )
    }
    return (
      <Field
        name={missionPEField(element)}
        component={SelectField}
        hintText="Elige una opción"
        validate={element.required === true ? this.required : () => undefined}
        fullWidth
      >
        {element.page_element_options.map(peo =>
          <MenuItem key={peo.id} value={peo.id} primaryText={peo.option_value} />,
          )}
      </Field>
    )
  }

}

SelectElement.propTypes = {
  element: React.PropTypes.shape({
    id: React.PropTypes.number.isRequired,
    has_answer: React.PropTypes.bool.isRequired,
    required: React.PropTypes.bool.isRequired,
    page_element_options: React.PropTypes.arrayOf(React.PropTypes.shape({
      id: React.PropTypes.number.isRequired,
      is_correct_answer: React.PropTypes.bool.isRequired,
      option_value: React.PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
}

const mapStateToProps = state => ({
  ...state,
})

const mapDispatchToProps = () => ({
})


export default connect(mapStateToProps, mapDispatchToProps)(SelectElement)



// WEBPACK FOOTER //
// ./src/components/MissionShow/MissionPage/FormPage/PageElement/SelectElement/index.jsx